import { useState } from "react";
import { send } from "emailjs-com";
import LinkedInLogo from "./../data/icons/linkedin.png";
import GithubLogo from "./../data/icons/github.svg";

export const Contact = () => {
  const [emailInfo, setEmailInfo] = useState({
    from_name: "",
    to_name: "mrmicrowaveoven@gmail.com",
    message: "",
    reply_to: "",
  });
  const [emailSending, setEmailSending] = useState(false);
  const [emailSentStatus, setEmailSentStatus] = useState(null);
  const handleChange = (e) => {
    setEmailInfo({ ...emailInfo, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setEmailSending(true);
    send(
      process.env.REACT_APP_EMAIL_SERVICE_ID,
      process.env.REACT_APP_EMAIL_TEMPLATE_ID,
      emailInfo,
      process.env.REACT_APP_EMAIL_PUBLIC_KEY
    )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        setEmailSentStatus(true);
        setEmailSending(false);
      })
      .catch((err) => {
        console.log("FAILED...", err);
        setEmailSentStatus(false);
        setEmailSending(false);
      });
  };

  const formValid = Object.keys(emailInfo)
    .map((key) => {
      return emailInfo[key].trim() !== "";
    })
    .every((value) => value !== false);

  return (
    <div className="contact-body">
      <div className="contact-info">
        <div className="contact-info-title">Contact Info</div>
        <div className="contact-info-text">
          Currently residing in New Orleans, LA
        </div>
        <div className="contact-info-text">(714)809-9426</div>
        <div className="contact-icons">
          <a href="https://www.linkedin.com/in/bennyzagorski/" target="_blank">
            <img src={LinkedInLogo} className="contact-icon" />
          </a>
          <a href="https://github.com/MrMicrowaveOven" target="_blank">
            <img src={GithubLogo} className="contact-icon" />
          </a>
        </div>
        <div className="contact-info-text">
          Email me at&nbsp;
          <a href="mailto: benny@zagorski.com">Benny@Zagorski.com</a>
        </div>
      </div>
      <div className="contact-form">
        <div className="contact-form-title">Say Hello!</div>
        <form onSubmit={onSubmit} className="contact-form-fields">
          <fieldset
            disabled={emailSentStatus || emailSending ? "disabled" : ""}
            className="form-field-set"
          >
            <div>Name</div>
            <input
              type="text"
              name="from_name"
              placeholder="Name"
              className="contact-text-field"
              value={emailInfo.from_name}
              onChange={handleChange}
            />
            <div>Email</div>
            <input
              type="text"
              name="reply_to"
              placeholder="Email"
              className="contact-text-field"
              value={emailInfo.reply_to}
              onChange={handleChange}
            />
            <div>Message</div>
            <textarea
              type="text_area"
              name="message"
              placeholder="Message"
              className="contact-textarea-field"
              value={emailInfo.message}
              onChange={handleChange}
              rows="10"
              cols="30"
            />
            <br />
            <div className="confirmation-section">
              <button
                className="contact-button"
                type="submit"
                disabled={!formValid || emailSentStatus ? "disabled" : ""}
              >
                Submit
              </button>
              <div
                className={
                  emailSentStatus === true
                    ? "email-confirmation-message"
                    : "hidden"
                }
              >
                Email sent! You'll be hearing from me shortly!
              </div>
              <div
                className={
                  emailSentStatus === false
                    ? "email-confirmation-message"
                    : "hidden"
                }
              >
                Sorry, looks like something went wrong.
                <br />
                Try emailing me at{" "}
                <a href="mailto: benny@zagorski.com">Benny@Zagorski.com</a>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
};
